import { module } from 'angular';
import App from '../../../app';

class SCR0402Controller {
	
	constructor ($scope, $state, $uibModalInstance, $timeout, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(640, 420);
		this.initText();
		
		this.$timeout(() => {
			this.initMenuGridOption();
			this.getMenuList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = this.data.text;
	}
	
	initMenuGridOption(){
		this.gridView = new RealGridJS.TreeView('grid');
		this.dataProvider = new RealGridJS.LocalTreeDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setTreeOptions({lineVisible: false, expandImage: './assets/images/grid/expand.png', collapseImage: './assets/images/grid/collapse.png'});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
    		 {fieldName: "id"}, {fieldName: "name"}, {fieldName: "check", dataType: 'boolean'},
    		 {fieldName: "parentId"}, {fieldName: "description"}, {fieldName: "seq"}
        ]);
		
		this.gridView.setColumns([
			{ name: "id", fieldName: "id", header : { text: this.text.menuId }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "name", fieldName: "name", header : { text: this.text.menuNm }, width: 100, styles: { textAlignment: 'center' } }
		]);
		
		this.gridView.onItemChecked = (grid, itemIndex, checked) => {
			grid.setValue(itemIndex, 2, checked);
			
			let row = grid.getValues(itemIndex);
			
			if(row.parentId){
				let parentItemIdx = grid.getParent(itemIndex);
				
				if(checked) {
					grid.checkItem(parentItemIdx, checked, false, false);
					grid.setValue(parentItemIdx, 2, checked);
				}else{
					let count = 0;
					let children = grid.getChildren(parentItemIdx);
					
					children.map((v) => {
						let childrenRow = grid.getValues(v);
						
						if(childrenRow.check == false) {
							count++;
						}
					}); 
					
					if(count == children.length) {
						grid.checkItem(parentItemIdx, checked, false, false);
						grid.setValue(parentItemIdx, 2, checked);
					}
				}
			}else{
				grid.getChildren(itemIndex).map((v) => {
					grid.checkItem(v, checked, false, false);
					grid.setValue(v, 2, checked);
				});
			}
		};
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getMenuList() {
		const roleId = this.data.roleId;
		
		this.httpService.get(`/roles/${roleId}/menupopups`).then(data => {
			data.map((v) => {
				v.check = false;
			});
			
			let treeData = this.gridService.convertTreeData(data, "parentId", "id");
			
			this.dataProvider.setJsonRows(treeData, 'rows', '');
			
			this.gridView.expandAll();
		});
	}
	
	closeModal(isOk){
		if(isOk){
			let treeData = this.dataProvider.getJsonRows(-1, true, 'rows');
			let data = this.gridService.convertArrayData(treeData, 'parentId')
			
			this.$uibModalInstance.close(data);
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
}

module(App.name).controller('SCR0402Controller', SCR0402Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0402/SCR0402.controller.js